import { PropsWithChildren } from "react";
import { ConfigProvider, theme } from "antd";
import { StyleProvider } from "@ant-design/cssinjs";
import { useTheme } from "../../lib/theme-context";

const themeConfig = require("../../theme.config.js");

export const AntdTheme: React.FC<PropsWithChildren<{}>> = ({ children }) => {
  const { effectiveTheme } = useTheme();

  const antdColors = {
    colorPrimary: themeConfig.primary,
  };

  return (
    <ConfigProvider
      theme={{
        algorithm: effectiveTheme === "dark" ? theme.darkAlgorithm : theme.defaultAlgorithm,
        token: antdColors,
        components: {
          Splitter: {
            splitBarDraggableSize: 40,
          },
        },
      }}
    >
      <StyleProvider hashPriority="high">{children}</StyleProvider>
    </ConfigProvider>
  );
};
